module.exports = __webpack_public_path__ + "img/ul.dc011e38.svg";